import { OrderManagementResource, useOrderLogsCommon } from '@eih-netbroker/common';
import { useMemo } from 'react';
import { useResource, useResourceHeaders } from './useResource';

export const useOrderLogs = () => {
  const orderManagementResource = useResource(OrderManagementResource);
  const { getResourceHeaderForMultiAccount } = useResourceHeaders();

  const p = useMemo(
    () => ({
      orderManagementResource,
      getResourceHeaderForMultiAccount,
    }),
    [orderManagementResource, getResourceHeaderForMultiAccount],
  );

  return useOrderLogsCommon(p);
};
